import React from 'react';
import cx from 'classnames';
import NavLink from '../../components/NavLink';

import CircleDecor4 from '../../components/Svg/circle-decor-4';
import CircleDecor5 from '../../components/Svg/circle-decor-5';
import RGlow1 from '../../components/Svg/radial-glow-1';
import {withUiContext} from '../../UiContext';

const NavContentLink = ({icon, label, link, className, ...props}) => {
    const {driverStatus = false, introStatus = false, ui} = props;
    const handleClick = () => {
        ui.setDriverStatus(driverStatus);
        ui.setIntroStatus(introStatus);
    };

    return (
        <NavLink
            className = { cx('btn btn-nav-item', className) }
            to = { link }
            onClick = { handleClick }
        >
            <div className = 'btn__icon'>{icon}</div>

            <div className = 'btn__label btn__label__bottom'>
                {label}
            </div>

            <div className = 'btn__circles'>
                <div className = 'btn__circles__item'><CircleDecor4/></div>
                <div className = 'btn__circles__item'><CircleDecor5/></div>
            </div>

            <div className = 'btn__glow'>
                <RGlow1/>
            </div>
        </NavLink>
    );
};

export default withUiContext(NavContentLink);
